/* TEKTO accessibility fixes (audit item M14).
   Gives screen readers a name for controls that only show their text through CSS or a placeholder,
   and marks icons inside already-labelled buttons and links as decorative. */
(function () {
  'use strict';

  var INPUT_LABELS = [
    ['input[data-quantity]', 'Quantity'],
    ['[data-personalization-input]', 'Custom blade engraving text'],
    ['[data-waitlist-email]', 'Email address']
  ];

  function hasLabel(el) {
    if (el.getAttribute('aria-label') || el.getAttribute('aria-labelledby')) return true;
    return !!(el.labels && el.labels.length);
  }

  function labelAddToCart(root) {
    // The visible text is drawn by CSS from data-button-label, which screen readers do not announce.
    var buttons = root.querySelectorAll('[data-add-to-cart][data-button-label]');
    for (var i = 0; i < buttons.length; i++) {
      var label = (buttons[i].getAttribute('data-button-label') || '').replace(/\s*\|\s*/g, ', ').trim();
      if (label && buttons[i].getAttribute('aria-label') !== label) buttons[i].setAttribute('aria-label', label);
    }
  }

  function labelInputs(root) {
    for (var i = 0; i < INPUT_LABELS.length; i++) {
      var els = root.querySelectorAll(INPUT_LABELS[i][0]);
      for (var j = 0; j < els.length; j++) {
        if (!hasLabel(els[j])) els[j].setAttribute('aria-label', INPUT_LABELS[i][1]);
      }
    }
    // Any other text field with no label: use its placeholder text.
    var fields = root.querySelectorAll('input[placeholder]:not([type="hidden"]):not([aria-label]), textarea[placeholder]:not([aria-label])');
    for (var k = 0; k < fields.length; k++) {
      var ph = (fields[k].getAttribute('placeholder') || '').replace(/[.…]+$/, '').trim();
      if (ph && !hasLabel(fields[k])) fields[k].setAttribute('aria-label', ph);
    }
  }

  function decorativeIcons(root) {
    // Images with no alt inside a button or link that already has a name are icons; hide them from screen readers.
    var imgs = root.querySelectorAll('a img:not([alt]), button img:not([alt])');
    for (var i = 0; i < imgs.length; i++) {
      var ctl = imgs[i].closest('a, button');
      if (ctl && (ctl.getAttribute('aria-label') || ctl.textContent.trim())) imgs[i].setAttribute('alt', '');
    }
  }

  function cleanImageAlts(root) {
    // Product photo alt text doubles as variant-matching codes ("Forged Ember // Black Accents,,File-Name").
    // The theme matches variants by image URL, so the spoken text can be tidied: "F2 Bravo, Forged Ember, Black Accents".
    var imgs = root.querySelectorAll('img[alt*=",,"]');
    if (!imgs.length) return;
    var h1 = document.querySelector('h1');
    var name = h1 ? h1.textContent.replace(/\s+/g, ' ').trim() : '';
    for (var i = 0; i < imgs.length; i++) {
      var detail = imgs[i].getAttribute('alt').split(',,')[0]
        .replace(/\s*\/\/\s*/g, ', ')
        .replace(/\s*--\s*/g, ', ')
        .replace(/\s+/g, ' ')
        .trim();
      var alt = name && imgs[i].closest('.tk-product-main') ? name + (detail ? ', ' + detail : '') : detail;
      imgs[i].setAttribute('alt', alt);
    }
  }

  function run() {
    labelAddToCart(document);
    cleanImageAlts(document);
    labelInputs(document);
    decorativeIcons(document);
  }

  var timer = null;
  function schedule() {
    if (timer) return;
    timer = setTimeout(function () { timer = null; run(); }, 150);
  }

  function start() {
    run();
    if (!window.MutationObserver) return;
    new MutationObserver(schedule).observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-button-label', 'alt']
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
